<template>
  <div class="goodstype" id="goodstype">
    <GlobTopNav title="商品分类"></GlobTopNav>

    <!--主体-->
    <div class="conter">
      <div class="listCont">
        <div class="list-item" @click="go(-1, '全部商品')">
          <img class="list-img" src="/static/images/all.png" alt="" />
          <div class="list-title">
            <h2>全部商品</h2>
            <!-- <p class="ellipse">PRODUCTS</p> -->
          </div>
        </div>
        <div
          v-for="(items, index) in datas"
          :key="items.id"
          @click="go(items.id, items.name)"
          class="list-item"
        >
          <img class="list-img" alt="" :src="items.image" onerror="src='/static/images/all.png'" />
          <div class="list-title">
            <h2>{{ items.name }}</h2>
            <!-- <p class="ellipse">PRODUCTS</p> -->
          </div>
        </div>
      </div>
      <div class="nomore">
        <div class="theEnd">已经到底了</div>
      </div>
    </div>
    <!--底部导航-->
    <footer-nav></footer-nav>
  </div>
</template>

<script>
import Password from '../user/personal/password'
import TopNav from '../../components/topnav'
import Bus from '../../../static/js/bus.js'
import FooterNav from '../../components/footernav'
export default {
  components: { Password, TopNav, FooterNav },
  name: 'goodstype',
  props: ['configData'],
  data() {
    return {
      datas: '', //商品数据
      search_keywords: '', //搜索关键词
      loading: false, //下拉加载状态
      finished: false //下拉加载是否开启
    }
  },
  //    beforeRouteLeave(to,from ,next){//解决分类列表进入后缓存与详情返回重新刷新页面的问题（重要内容）
  //      console.log(to)
  //      if(to.name=='GoodsList'){
  //        to.meta.keepAlive =false;
  //        console.log(to)
  //      }
  //      next()
  //    },
  watch: {
    $route(to, form) {
      if (to.name == 'GoodsList' && form.name == 'Home' && to.query != form.query) {
        this.datas = []
        this.page = 0
        if (this.finished) {
          this.finished = false
        } else {
          this.getDatas()
        }
      }
    }
  },
  methods: {
    goBack: function () {
      history.back(-1)
    },
    onClickRight() {
      this.$refs.TopNav.topnavPlay()
    },
    // 获取数据
    getdatas: function (name) {
      var mallid = localStorage.getItem('mallid')
      this.$api.get('/sys/typelist', { id_example: mallid, terminal: 'wap', name: name }, res => {
        if (res.data.code == '100') {
          this.datas = res.data.data
        }
      })
    },
    go: function (id, name) {
      //        setTimeout(function () {
      //          Bus.$emit('notice', name)
      //        },50)
      this.$router.push({ path: '/goodsList', query: { id: id } })
    },
    // 搜索关键词
    onSearch: function () {
      var mallid = localStorage.getItem('mallid')
      if (this.search_keywords != undefined && this.search_keywords != '') {
        this.datas = []
        this.page = 0

        if (this.finished) {
          this.finished = false
        } else {
          this.loading = true
          this.getdatas(this.search_keywords)
        }
      } else {
        this.$toast('请输入要搜索的分类！')
      }
    }
  },
  mounted() {
    this.getdatas('')
    window.addEventListener('scroll', this.handleScroll)
  },
  created() {},
  updated() {}
}
</script>
<style lang="less">
.goodstype {
  background: #f5f5f5;
  min-height: 100vh;
  padding-bottom: 1rem;

  .conter {
    width: 100%;
    box-sizing: border-box;
    padding: 0 0.2rem;
    .listCont {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-content: flex-start;
      flex-wrap: wrap;

      .list-item {
        width: 3.44rem;
        height: 1.8rem;
        background: #ffffff;
        border-radius: 0.12rem;
        margin-top: 0.2rem;
        box-sizing: border-box;
        padding: 0 0.3rem;
        display: flex;
        align-items: center;

        .list-img {
          width: 1rem;
          height: 1rem;
          background: linear-gradient(180deg, #f9f7f7 0%, #f0f0f0 100%);
          border-radius: 0.34rem;
          display: flex;
          align-items: flex-end;
          justify-content: center;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .list-title {
          display: flex;
          flex-direction: column;
          margin-left: 0.26rem;
          h2 {
            width: 1.6rem;
            font-size: 0.28rem;
            font-weight: 500;
            color: #262626;
            line-height: 0.48rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .ellipse {
            font-size: 0.24rem;
            font-family: PingFang-SC-Regular, PingFang-SC;
            font-weight: 400;
            color: rgba(38, 38, 38, 0.5);
            line-height: 0.42rem;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/goods/goodstype.vue